
























































































import {Component} from 'vue-property-decorator';
import {Getter, Action} from "vuex-class";
import OriginatorsFilter from "@/components/Originators/OriginatorsFilter.vue";
import {OriginatorItem} from "@/store/originators/types";
import {LongTextWings} from '@/components';
import ScrollButton from "@/components/ScrollButton.vue";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { notifyError, notifyDelete } from '@/utils/notify-helper';

@Component({components: {OriginatorsFilter,LongTextWings,ScrollButton}})
export default class Originators extends BaseItemsPage<OriginatorItem> {
  @Getter("originators") originatorResponse: any;
  @Action("deleteOriginator") actionDelete: any;
  private is_show_filter = false;
  currentSort= "name";
  currentSortOrder= "desc";
  tableFields = [
    'name',
    'transport',
    'status',
    'comment',
  ];

  getData(): any {
    return this.originatorResponse;
  }

  async onDeleteItem(item: OriginatorItem):Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        await this.actionDelete({ senderId: item.id })
      } catch (error) {
        notifyError(error);
      }
    }
  }

  itemColor(status:string){
    switch (status) {
      case 'ACCEPTED':
        return 'background-chip-success'
      case 'DENIED':
        return 'background-chip-danger'
      default:
        return 'background-chip-warning'
    }
  }

}
